import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'

export const Marketplace = (props: LevelProps) => {
  return <LevelPage {...props} cardSize="small" cards={LEVEL_CARDS.L2.MARKETPLACE} />
}
